import { faqs, serviceAreas } from './site-content';

export const crawlerContentMarker = '<!-- atlas-ag:crawler-content -->';
export const jsonLdMarker = '<!-- atlas-ag:json-ld -->';

function escapeHtml(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function renderCrawlerContent() {
  const serviceAreaItems = serviceAreas
    .map(
      ({ name, description }) =>
        `            <li><strong>${escapeHtml(name)}</strong>${
          description ? ` — ${escapeHtml(description)}` : ''
        }</li>`,
    )
    .join('\n');
  const faqItems = faqs
    .map(
      ({ question, answer }) =>
        `          <article><h3>${escapeHtml(question)}</h3><p>${escapeHtml(
          answer,
        )}</p></article>`,
    )
    .join('\n');

  return `        <section aria-labelledby="crawlable-service-area-heading">
          <h2 id="crawlable-service-area-heading">Service area</h2>
          <p>Atlas AG works with businesses in these areas, with remote work available nationally.</p>
          <ul>
${serviceAreaItems}
          </ul>
        </section>
        <section aria-labelledby="crawlable-faq-heading">
          <h2 id="crawlable-faq-heading">Frequently asked questions</h2>
${faqItems}
        </section>`;
}

export function renderJsonLd() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'ProfessionalService',
        '@id': 'https://atlasag.co/#organization',
        name: 'Atlas AG',
        url: 'https://atlasag.co/',
        description:
          'Atlas AG builds purpose-fit software around the real problems businesses need solved, turning specific workflows into tools that fit how the work is done.',
        areaServed: serviceAreas.map(({ schemaType, name, description }) => ({
          '@type': schemaType,
          name,
          ...(description ? { description } : {}),
        })),
        sameAs: [
          'https://maintaintime.com',
          'https://advisewithease.com',
          'https://brokerwithease.com',
          'https://inswithease.com',
          'https://insightadvantage.io',
          'https://emailbridge.app',
          'https://idahosoilhealth.com',
          'https://tvcompost.com',
          'https://recipepro.io',
          'https://invoiceable.app',
          'https://clurkel.com',
          'https://fitnessfor.app',
        ],
      },
      {
        '@type': 'Service',
        name: 'Custom software development',
        serviceType: 'Custom software development',
        provider: { '@id': 'https://atlasag.co/#organization' },
        description:
          'Purpose-fit software development for businesses that need a solution shaped around a specific problem, workflow, or opportunity.',
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqs.map(({ question, answer }) => ({
          '@type': 'Question',
          name: question,
          acceptedAnswer: { '@type': 'Answer', text: answer },
        })),
      },
    ],
  };

  // Prevent content containing a less-than sign from closing the script element.
  return JSON.stringify(structuredData, null, 2).replace(/</g, '\\u003c');
}